// atoms/document.ts
import { atom } from "recoil";
import { getAPI } from "@/api";
import { Document } from "@/types/entities";

export const documentState = atom<Document[]>({
  key: "documentState",
  default: [],
});

const API = getAPI();

/**
 * Create a new asset and update the Recoil state.
 * @param {File} document - The file to upload.
 * @param {Function} setDocuments - Function to update the document state.
 * @param {string} [docKey] - Optional document key.
 * @return {Promise<{ imageUrl: string }>} The upload result.
 */
export async function createDocument(
  document: File | Document,
  setDocuments: (callback: (documents: Document[]) => Document[]) => void,
  docKey?: string
): Promise<{ imageUrl: string }> {
  if (document instanceof File) {
    try {
      const _document = await API.document.createDocument(document, docKey);
      setDocuments((prevDocuments) => [
        ...prevDocuments,
        {
          id: docKey,
          title: document.name,
          type: document.type.split("/").pop() as "pdf" | "csv" | "txt",
          content: "",
          uploaded_at: new Date().toISOString(),
          owner_id: "",
        },
      ]);
      return {
        imageUrl: _document.message,
      };
    } catch (error) {
      console.error(`Error uploading document with key ${docKey}:`, error);
      return {
        imageUrl: `Failed to upload document with key ${docKey}.`,
      };
    }
  } else {
    try {
      setDocuments((prevDocuments) => [...prevDocuments, document]);
      return { imageUrl: "" };
    } catch (error) {
      console.error(
        `Error adding document to state with key ${docKey}:`,
        error
      );
      return {
        imageUrl: `Failed to add document to state with key ${docKey}.`,
      };
    }
  }
}
